import React from 'react';
import ReactDOM from 'react-dom';

import domReady from "@wordpress/dom-ready";

import { NoticeBlack } from '@wpmudev/shared-notifications-black-friday';

function hideNotice() {
	const shipperBfContainer = document.getElementById('shipper-black-friday-notice');
	const nonce = shipperBfContainer.dataset.nonce;
	const xhr = new XMLHttpRequest();
	xhr.open('POST', ajaxurl + '?action=shipper_hide_black_friday', true);
	xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	xhr.send('_wpnonce=' + nonce);
}

domReady(function () {
	const shipperBfContainer = document.getElementById('shipper-black-friday-notice');
	if (shipperBfContainer) {
		ReactDOM.render(
			<NoticeBlack link={window.shipper_bf.link} onCloseClick={hideNotice}>
				<p>
					<strong>{window.shipper_bf.header}</strong>{' '}
					{window.shipper_bf.message}
				</p>
				<p>
					<small>{window.shipper_bf.notice}</small>
				</p>
			</NoticeBlack>,
			shipperBfContainer
		);
	}
});
